import { isDefined } from '@sgme/fp';
import classNames from 'classnames';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { TextValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';
import { camelCaseToWords } from 'utils/string';

export interface ProductSummaryTextFieldProps {
  node: TextValueDefinition;
}

export const ProductSummaryTextField: FC<ProductSummaryTextFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);
  const translationKey = node.translationKey ?? node.id;
  const isHighlighted = node.isHighlighted ?? false;
  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p
        className={classNames('text-large m-0', {
          'fw-light': !isHighlighted,
          'fw-bold': isHighlighted,
          'text-danger': isHighlighted,
        })}
        data-e2e={`product-summary-field-${node.id}`}
      >
        {isDefined(data) && (
          <FormattedMessage id={`field.${data}` as IntlKey} defaultMessage={camelCaseToWords(data)} />
        )}
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryTextField.displayName = 'ProductSummaryTextField';
